module.exports = __webpack_public_path__ + "bc0c5d6c92f3517885d441c3ed3b20c1.svg";